var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import './Counter.scss';
var Counter = function (_a) {
    var _b, _c;
    var targetDate = _a.targetDate, _d = _a.metadataMap, metadataMap = _d === void 0 ? null : _d, className = _a.className, style = _a.style, containerStyles = _a.containerStyles, labelStyles = _a.labelStyles, valueStyles = _a.valueStyles;
    var _e = __read(useState(getTimeRemaining(convertToTimestamp(targetDate))), 2), timeRemaining = _e[0], setTimeRemaining = _e[1];
    var genericMessages = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.genericMessages;
    useEffect(function () {
        var interval = setInterval(function () {
            var timeLeft = getTimeRemaining(convertToTimestamp(targetDate));
            if (timeLeft.total <= 0) {
                clearInterval(interval);
                window.location.reload();
            }
            setTimeRemaining(timeLeft);
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [targetDate]);
    function convertToTimestamp(date) {
        if (typeof date === 'number') {
            return date; //Unix time stamp
        }
        else if (date instanceof Date) {
            return date.getTime(); //Date object to timestamp (milliseconds)
        }
        return Date.now();
    }
    function getTimeRemaining(endTime) {
        var currentTime = Date.now();
        var total = endTime - currentTime;
        var seconds = Math.floor((total / 1000) % 60);
        var minutes = Math.floor((total / 1000 / 60) % 60);
        var hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        var days = Math.floor((total / (1000 * 60 * 60 * 24)) % 30);
        var months = Math.floor((total / (1000 * 60 * 60 * 24 * 30)) % 12);
        var years = Math.floor(total / (1000 * 60 * 60 * 24 * 365));
        return {
            total: total,
            years: years,
            months: months,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
        };
    }
    function renderTimeDisplay() {
        if (timeRemaining.years > 0) {
            return (React.createElement("div", null,
                timeRemaining.years,
                ' ',
                timeRemaining.years > 1 ? (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.yearTextPlural) || 'Years' : (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.yearText) || 'Year',
                timeRemaining.months > 0 && (React.createElement(React.Fragment, null,
                    ", ",
                    timeRemaining.months,
                    ' ',
                    timeRemaining.months > 1
                        ? (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.monthTextPlural) || 'Months'
                        : (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.monthText) || 'Month'))));
        }
        else if (timeRemaining.months > 0) {
            return (React.createElement("div", null,
                timeRemaining.months,
                ' ',
                timeRemaining.months > 1
                    ? (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.monthTextPlural) || 'Months'
                    : (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.monthText) || 'Month',
                timeRemaining.days > 0 && (React.createElement(React.Fragment, null,
                    ", ",
                    timeRemaining.days,
                    ' ',
                    timeRemaining.days > 1 ? (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.dayTextPlural) || 'Days' : (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.dayUpper) || 'Day'))));
        }
        else if (timeRemaining.days >= 1) {
            return (React.createElement("div", null,
                timeRemaining.days,
                " ",
                timeRemaining.days > 1 ? (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.dayTextPlural) || 'Days' : (genericMessages === null || genericMessages === void 0 ? void 0 : genericMessages.dayUpper) || 'Day'));
        }
        else {
            return (React.createElement("div", { className: "countdown-timer" },
                React.createElement("div", { className: "time-box" },
                    timeRemaining.hours.toString().padStart(2, '0'),
                    " "),
                React.createElement("span", null, " : "),
                React.createElement("div", { className: "time-box" },
                    " ",
                    timeRemaining.minutes.toString().padStart(2, '0'),
                    " "),
                React.createElement("span", null, " : "),
                React.createElement("div", { className: "time-box" },
                    " ",
                    timeRemaining.seconds.toString().padStart(2, '0'))));
        }
    }
    return (timeRemaining.total > 0 ?
        React.createElement("div", { className: "counter-overlay ".concat(className), style: style },
            React.createElement("div", { className: "counter-container", style: containerStyles },
                React.createElement("div", { className: "static-label", style: labelStyles }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.videoStartInText) || 'Available in: '),
                React.createElement("div", { className: "time-text", style: valueStyles }, renderTimeDisplay()))) : null);
};
export default Counter;
